export function shouldShowHeaderNavigationForV2(path: string) {
  return !path.startsWith('/v1') && !path.endsWith('/legacy-export');
}
